import DxmlElements from "../DxmlElements"
import { useContext, useRef, useEffect, useState } from "react"
import { SelectableTextContext } from "../../../../../contexts"
import { useEditorFile } from "../../../../../hooks/useEditorFile";
import * as Constants from "../../../../../utils/constants";

export default function DxmlTextPart({ editorTextPart, editorTextChoice }) {
    const { selectedTextPartIdRef, hoveredSelectableText } = useContext(SelectableTextContext);
    const { getChildItemsToShow, getKeyById } = useEditorFile();
    const [hoveredVisible, setHoveredVisible] = useState(undefined);

    const cssClassName = () => {
        let cssClass = "";
        let hoveredTextPart = findTextPartInHoveredSelectableText();
        if (hoveredTextPart?.Visible) {
            cssClass = cssClass + " ";
        }
        if (selectedTextPartIdRef.current === editorTextPart.Id) {
            cssClass = cssClass + " ";
        }
        return cssClass;
    }


    useEffect(() => {
        if (selectedTextPartIdRef.current === editorTextPart.Id && editorTextPart.Visible) {
            const selectedEditorTextPartElement = document.getElementById(selectedTextPartIdRef.current);
            const dxmlDocumentElement = document.getElementById(Constants.dxmlDocumentContainerId);
            if (selectedEditorTextPartElement && dxmlDocumentElement) {
                dxmlDocumentElement.scrollTop = selectedEditorTextPartElement.offsetTop - dxmlDocumentElement.offsetTop;
            }
        }
    }, [selectedTextPartIdRef.current])

    const findTextPartInHoveredSelectableText = () => {
        let textPart = null;
        if (hoveredSelectableText?.Type === Constants.editorType.textChoice) {
            textPart = hoveredSelectableText.Items?.find(x => x.Type === Constants.editorType.textPart && x.Id === editorTextPart.Id);
        } else if (hoveredSelectableText?.Type === Constants.editorType.textPart && hoveredSelectableText?.Id === editorTextPart.Id) {
            textPart = hoveredSelectableText;
        }
        return textPart;
    }

    const scrollDxmlDocumentToTop = () => {
        const dxmlDocumentElement = document.getElementById(Constants.dxmlDocumentContainerId);
        if (dxmlDocumentElement) {
            dxmlDocumentElement.scrollTop = 0;
        }
    }

    const handleHoverOverUnselectedText = (newHoveredVisible) => {
        // When the user previews predefined unselected text (checkbox), it will inserts a new element. 
        // When the mouse leaves the unselected text, it will delete the element.
        // If the dxml document is scrolled down before insert or delete, inserting/deleting element may cause the whole page to scroll down automatically.
        if (newHoveredVisible === hoveredVisible) return;
        if (editorTextPart.Visible === true) return;

        if (newHoveredVisible !== undefined) {
            // mouse enter 
            scrollDxmlDocumentToTop();
        } else {
            // mouse leave
            if (!editorTextChoice || editorTextChoice.IsRadioGroupMode === false || hoveredVisible === true) {
                scrollDxmlDocumentToTop();
            }
        }
    }

    useEffect(() => {
        const textPart = findTextPartInHoveredSelectableText();

        const newHoveredVisible = !textPart ? undefined : textPart.Visible;
        setHoveredVisible(newHoveredVisible);

        handleHoverOverUnselectedText(newHoveredVisible);
    }, [hoveredSelectableText])

    useEffect(() => {
        if (hoveredVisible) {
            const hoveredEditorTextPartElement = document.getElementById(editorTextPart.Id);
            const dxmlDocumentElement = document.getElementById(Constants.dxmlDocumentContainerId);
            if (hoveredEditorTextPartElement && dxmlDocumentElement) {
                dxmlDocumentElement.scrollTop = hoveredEditorTextPartElement.offsetTop - dxmlDocumentElement.offsetTop;
            }
        }
    }, [hoveredVisible])

    if ((hoveredVisible === undefined && !editorTextPart.Visible) || hoveredVisible === false) {
        return <></>
    }

    return (
        <div id={editorTextPart.Id} title={editorTextPart.Description} className={cssClassName()}>
            <DxmlElements editorBaseModel={editorTextPart} />
        </div>
    )
}